<div class="p-b">
    <p class="fw-bold s1"
       *iCms="'header' of content; skipEmpty: true"></p>

    @if (content?.top) {
    @for (term of popularSearches; track $index) {
    <div class="m-t-1">
        <a class="block m-t-1-s p-t-1 p-b-1 p1"
           [routerLink]="['search', term]">{{term}}</a>
    </div>
    }
    }
    <div class="m-t-2"
         [grid]="[2,2,4,4][client.sizeId]">
        @for (item of content?.items; track $index) {
        @if (!item.hide) {
        <href [link]="item.link"
              [attr.title]="item.title">
            <img class="w-12"
                 [dfImage]="item.image"
                 [alt]="item.title"
                 [sizes]="['50vw', '50vw', '20vw', '20vw']"
                 [minSize]="256"
                 [maxSize]="1080"
                 ratio="3/4">

            <p class="m-t-2 p1"
               *iCms="'title' of item; skipEmpty: true"></p>
        </href>
        }
        }
    </div>
</div>